import React from 'react';
import { useHistory } from 'react-router';
import classNames from 'classnames';

import lang from '../../../lib/language';

import TradeViewBtnIcon from '../../../assets/img/trade_chart_btn.svg';
import useIsMobile from '../../../hooks/useIsMobile';
import { UI_ROUTES } from '../../../util/routes';
import { ClickableDiv } from '../..';

import styles from './TradeViewChartButton.module.scss';

type Props = {
  symbol: string;
};

const TradeViewChartButton = ({ symbol }: Props) => {
  const isMobile = useIsMobile();
  const history = useHistory();

  const onMobileClick = () => {
    if (isMobile) {
      history.push(`${UI_ROUTES.tradingView}/${symbol}`);
    }
  };
  return (
    <ClickableDiv
      className={classNames(styles.wrapper, { [styles.wrapperMob]: isMobile })}
      onClick={onMobileClick}
    >
      <img src={TradeViewBtnIcon} alt="Tradeview Chart" />
      {!isMobile && (
        <a href={`${UI_ROUTES.tradingView}/${symbol}`} target={'_self'} rel="noreferrer">
          {lang.tradingViewChartLabel()}
        </a>
      )}
    </ClickableDiv>
  );
};

export default TradeViewChartButton;
